import Vue from "vue";
import PortalVue from "portal-vue";
import VueRouter from "vue-router";
import "./jquery-global.js";
import axios from "axios";

// Components
import { RepresentativeFinder } from "./blocks/representative_finder.js";
import SiteNav from "./components/SiteNav";
import ThumbnailGrid from "./components/ThumbnailGrid";
import SearchThumbnailGrid from "./blocks/SearchThumbnailGrid";
import DownloadsTable from "./components/DownloadsTable";
import SampleMaterialGallery from "./components/SampleMaterialGallery";
import ModalController from "./components/ModalController";
import Clipboard from "./components/configurator/Clipboard";
import Wizard from "./components/configurator/Wizard";
import InlineModal from "./components/InlineModal";
import HyperlinkGateForm from "./components/HyperlinkGateForm";
import VideoGridWithModal from "./components/VideoGridWithModal";
import ProductActionBlock from "./atoms/product_action_block.vue";

// Scripts
import { checkForAbImages } from "./blocks/ab_image_drag.js";
import { checkForBackToTop } from "./back_to_top.js";
import { updateBillboardStyling } from "./blocks/billboard-header.js";
import { checkForBillboardSliders } from "./blocks/billboard_slider.js";
import { checkForBillboardTabs } from "./blocks/billboard_tabs.js";
import { checkForForms } from "./blocks/form.js";
import { checkForMediaCarousels } from "./blocks/media_carousel.js";
import { checkForMediaGalleries } from "./blocks/media_gallery.js";
import { checkForMultiPaneContent } from "./blocks/multi_pane_content.js";
import { checkForProductDetail } from "./blocks/product-detail-utility.js";
import { checkForTimelapse } from "./blocks/timelapse_drag.js";
import { checkForTimelines } from "./blocks/timeline.js";
import { checkForQuoteCarousels } from "./blocks/quote_carousel.js";
import { listenForLoadMore } from "./load_more.js";
import { forcePageReloadOnAnchorHrefClick } from "./blocks/sub_nav.js";
import { swapBillboards } from "./billboard_swap.js";
import { watchForMenuClick } from "./mobile-menu.js";
import { checkForLinkify } from "./linkify.js";
import { downloadTableScroll } from "./download_table_scroll.js";
import { setupRelatedProductsCarousel } from "./blocks/related_products.js";

import Flickity from "flickity";
import "regenerator-runtime";

Flickity.defaults.arrowShape = {
  x0: 20,
  x1: 55,
  y1: 50,
  x2: 70,
  y2: 45,
  x3: 40,
};

Vue.use(PortalVue);
Vue.use(VueRouter);

axios.interceptors.request.use(
  function(config) {
    config.withCredentials = true;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

const router = new VueRouter({
  mode: "history",
});

window.Vue = new Vue({
  router,
  el: "#app",
  delimiters: ["${", "}"],
  components: {
    SiteNav,
    RepresentativeFinder,
    ThumbnailGrid,
    SearchThumbnailGrid,
    DownloadsTable,
    SampleMaterialGallery,
    ModalController,
    Clipboard,
    Wizard,
    InlineModal,
    HyperlinkGateForm,
    VideoGridWithModal,
    ProductActionBlock
  },
  data: function() {
    return {
      modal: null,
    };
  },
  watch: {
    //
  },
  mounted() {
    const updateCsrfToken = () => {
      axios
        .get("/api/refresh-csrf-token")
        .then((response) => {
          window.Craft.csrfTokenName = response.data.csrfTokenName;
          window.Craft.csrfTokenValue = response.data.csrfTokenValue;
        })
        .catch((error) => {
          console.log(error);
        });
    };

    updateCsrfToken();
  },
  methods: {
    clearConfiguratorSelections(event) {
      const wizard = this.$refs.wizard;

      if (wizard) {
        event.preventDefault();
        wizard.complete();
      }
    },
    storeCurrentUrl() {
      localStorage.setItem("configRedirectBack", window.location.href);
    },
  },
});

checkForAbImages();
checkForBackToTop();
updateBillboardStyling();
checkForBillboardSliders();
checkForBillboardTabs();
checkForForms();
checkForMediaCarousels();
checkForMediaGalleries();
checkForMultiPaneContent();
checkForProductDetail();
checkForTimelapse();
checkForTimelines();
checkForQuoteCarousels();
forcePageReloadOnAnchorHrefClick();
listenForLoadMore();
swapBillboards();
watchForMenuClick();
checkForLinkify();
downloadTableScroll();
setupRelatedProductsCarousel();